module.exports = "https://static.wanderu.com/static/media/flight-grey.3dde7ad7.svg";